import React, { useState } from 'react'
import classNames from 'classnames'
import { RadioInputProps } from './RadioInput.d'

const RadioInput = ({
  id,
  label,
  name,
  onChange,
  options,
  textLeft = false
}: RadioInputProps) => {
  const [value, setValue] = useState<string>('' as string)

  const handleInputChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    setValue(ev.target.value)
    if (typeof onChange === 'function') {
      onChange(ev)
    }
  }

  const wrapperClassNames = classNames({
    'mr-3 flex-1 basis-3/4 w-auto brand2 mb-[10px]': true,
    'text-center [@media(min-width:992px)]:text-left': !textLeft,
    'text-left': textLeft
  })

  const labelClassNames = classNames({
    'w-[154px] !font-medium !font-effra text-[14px]': true
  })

  const inputClassNames = classNames({
    'mr-2 absolute h-[48px] w-[20px] border-[#2b4fb9] border-2 accent-[#2b4fb9] checked:color-[#2b4fb9] bg-[#666]':
      true
  })

  const optionLabelClassNames = classNames({
    '!font-effra !font-normal relative top-[9px] md:top-[2px] left-[30px] md:left-[25px] text-[14px] text-[#666] leading-[24px]':
      true
  })

  return (
    <div aria-label={id} className={wrapperClassNames}>
      <label className={labelClassNames} htmlFor={`${name}`}>
        {label}
      </label>
      <fieldset className='flex justify-between flex-wrap pt-3' id={`${name}`}>
        {options
          ? options.map(
              ({ value: optionValue, label: optionLabel }, i: number) => {
                return (
                  <label
                    className='w-full md:w-[33%] mb-4 inline-flex !font-normal text-[17px]'
                    htmlFor={`${name}-${i}`}
                    key={`${name}-${i}`}
                  >
                    <input
                      className={inputClassNames}
                      defaultChecked={i === 0}
                      id={`${id}-${name}-${i}`}
                      name={name}
                      onChange={(ev) => handleInputChange(ev)}
                      type='radio'
                      value={optionValue}
                    />
                    <span className={optionLabelClassNames}>{optionLabel}</span>
                  </label>
                )
              }
            )
          : null}
      </fieldset>
    </div>
  )
}

export default RadioInput
